
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/sliding-doors/aluprof/[slug]",
      function () {
        return require("private-next-pages/alu/sliding-doors/aluprof/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/sliding-doors/aluprof/[slug]"])
      });
    }
  